import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="policy-page-container">
      {/* Breadcrumb Section */}
      <div className="policy-breadcrumb">
        <div className="breadcrumb-content">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb-list">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Terms of Use
              </li>
            </ol>
          </nav>
          <h1 className="breadcrumb-title">Terms of Use</h1>
        </div>
      </div>

      <div className="policy-wrapper">
        <div className="policy-content">
          {/* Header Section */}
          <header className="policy-header">
            <p className="policy-update-date"><strong>Updated effective from 1st April, 2022</strong></p>
            <div className="policy-notice-banner">
              <h2>PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING OUR KYC & SECURITY SERVICES</h2>
              <p>
                This Website is owned and operated by <strong>payinfintech Payment Services Private Limited</strong>,
                which shall be hereafter referred to as "payinfintech Payment Services". By using the payinfintech Payment Services website
                (the "Site") or any payinfintech Payment Services applications or application plug-ins ("Applications") for our KYC/AML verification, identity management, and security consulting services, the User
                consent to obey and be bound by the terms of use (the "Terms") and consent to comply with all relevant
                laws and regulations that apply in India or abroad accordingly. In this Terms of Use, the words "You",
                "Your", "the User" and "the Users" refer to each User, Site visitor, or Application user. "We", "us"
                and "our" refer to https://payinfintech.in and "Services" refers to access to the KYC/AML compliance products, identity verification services, software,
                platform, websites and applications provided by payinfintech Payment Services.
              </p>
              <p>
                These Terms of Use is printed in accordance with the legal requirement provided under the provisions of
                the Information Technology Act, 2000. The Act requires that 'intermediaries' publish the rules and regulations,
                privacy policy and terms for access or usage of their Website and is primarily governed by Rule 3 (1) of the
                Information Technology (Intermediaries Guidelines) Rules, 2011.
              </p>
              <p>
                payinfintech Payment Services reserves the right to revise or alter these terms at any time. The User will be required
                to re-visit the page "Terms of Use" on our Website to keep up with any changes that we may introduce. The User's
                continued use of our KYC/AML and security services shall constitute the User's consent to such changes. If at any time the User find
                these Terms of Use unacceptable or does not agree to these Terms of Use, please refrain from using this Site or
                any of payinfintech Payment Services Applications. If the User has any questions about these Terms of Use, please contact
                payinfintech Payment Services at sales@payinfintech.com.
              </p>
              <p>
                By using our KYC/AML and security consulting Services, the User is agreeing to be bound by these General Terms as well as our Privacy Policy.
                The User also agrees that by using the Site and/or any Applications, and the services, the User is at least 18
                years of age and the User is legally fit to enter into a contract. If the User is using our Services as the
                employee or agent of any organization, the User is agreeing to these Terms at the behest of that organization.
              </p>
            </div>
          </header>

          {/* Terms Sections */}
          <div className="policy-sections">
            <section className="policy-section">
              <h2>INTRODUCTION</h2>
              <p>
                payinfintech Payment Services is a tech-driven technology company that aims to provide innovative KYC/AML compliance products & identity verification services
                for small, medium, and global businesses. At payinfintech Payment Services, we are committed to revolutionizing the way
                you manage your compliance and security needs. With a focus on innovation, regulatory alignment, and user-friendly solutions, we provide a
                comprehensive suite of services to meet all your identity verification and fraud prevention requirements.
              </p>
              <p>
                Discover the future of compliance with payinfintech Payment Services. Join us on this journey towards a more efficient,
                secure, and connected regulatory ecosystem. Experience the ease of managing KYC workflows, identity verification,
                and security solutions all in one place.
              </p>
            </section>

            <section className="policy-section">
              <h2>OWNERSHIP</h2>
              <p>
                All rights, title and interest in and to the materials provided on this Site and Applications, including but
                not limited to information, documents, KYC/AML workflows, compliance frameworks, logos, graphics, sounds and images (the "Materials") are owned either
                by payinfintech Payment Services or by our respective third party authors, developers or vendors ("Third Party Providers").
                Except as otherwise explicitly provided by payinfintech Payment Services, none of the Materials may be copied, reproduced,
                republished, downloaded, uploaded, posted, displayed, transmitted or distributed in any way and nothing on this
                site or on any Application shall be construed to confer any license under any of payinfintech Payment Services intellectual
                property rights. Any rights not expressly granted herein are reserved by payinfintech Payment Services.
              </p>
              <p>
                payinfintech Payment Services may at times provide a preview to the user documents, compliance templates, or any other product/services before
                purchase by the User. The information, content, organization, and structure of any such previews are all copyrighted,
                proprietary material owned by payinfintech Payment Services. Any violation of our copyright on such previews by Users is
                strictly prohibited.
              </p>
            </section>

            <section className="policy-section">
              <h2>LINKS TO THIRD PARTY WEBSITES</h2>
              <p>
                This site and applications may contain links to websites controlled by parties other than payinfintech Payment Services
                (each a "Third Party Site"), including KYC verification partners, identity document validation services, and regulatory compliance authorities. payinfintech Payment Services
                may also provide links to other citations or resources with
                whom it is not affiliated. payinfintech Payment Services is not responsible for and does not endorse or accept any
                responsibility for the availability, contents, products, services or use of any Third Party Site, any website
                accessed from a Third Party Site or any changes or updates to such sites. payinfintech Payment Services makes no guarantees
                about the content or quality of the products or services provided by such sites. payinfintech Payment Services is not
                responsible for webcasting or any other form of transmission received from any Third Party Site. payinfintech Payment
                Services is providing these links to the User only as a convenience, and the inclusion of any link does not
                imply endorsement by payinfintech Payment Services of the Third Party Site, nor does it imply that payinfintech Payment Services
                sponsors, is affiliated or associated with, guarantees, or is legally authorized to use any trade name, registered
                trademark, logo, legal or official seal, or copyrighted symbol that may be reflected in the links. The User
                acknowledges that the User bears all risks associated with access to and use of content provided on a Third Party
                Site and agrees that payinfintech Payment Services is not responsible for any loss or damage of any sort, the User may
                incur from dealing with a third party website. The User should write to sales@payinfintech.com if the User has any
                concerns regarding such links or the content located on any such Third Party Site.
              </p>
            </section>

            <section className="policy-section">
              <h2>LIMITATION ON USE</h2>
              <p>
                payinfintech Payment Services grants the User a limited, personal, non-exclusive, non-transferable license to use our
                KYC/AML compliance frameworks, identity verification workflows, and security templates (the "Documents") for the User's own personal, internal business use, for
                the User's client. Except as otherwise provided, the User acknowledges and agrees that the User has no right
                to modify, edit, copy, reproduce, create derivative works of, reverse engineer, alter, enhance or in any way
                exploit any of the Forms in any manner, except for modifications in using the Documents for the User's authorized
                use. The User shall not remove any copyright notice from any Document.
              </p>
            </section>

            <section className="policy-section">
              <h2>RESALE OF DOCUMENTS PROHIBITED</h2>
              <p>
                By purchasing or downloading KYC/AML compliance frameworks and security documents from payinfintech, the User agrees that the Documents may only
                be used by the User for the User's personal or business use or used by the User in connection with the User's
                client and may not be sold or redistributed without the express written consent of payinfintech.
              </p>
            </section>

            <section className="policy-section">
              <h2>DISCLAIMER OF CONTENT SUPPLIED BY USERS IN THE FORM OF REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT</h2>
              <p>
                At various locations on the Site or through Applications, payinfintech may permit Users to post ratings, reviews,
                comments, questions, answers, and other content regarding our KYC/AML and security services (the "User Content"). payinfintech disclaims all responsibility for
                this content. payinfintech has the right (but not the obligation), in our sole and absolute discretion, to edit, redact,
                remove, re-categorize to a more appropriate location or otherwise change any User Content.
              </p>
              <p>
                payinfintech also reserves the right to maintain, delete or destroy all such User Content posted, published or uploaded
                on the payinfintech site according to its internal record retention and/or destruction policies. If any offending material
                is brought to the notice of payinfintech, it will be deleted as soon as is possible. Whether such material is indeed
                offending will be finally being left to the discretion of payinfintech.
              </p>
            </section>

            <section className="policy-section">
              <h2>COMMUNICATION</h2>
              <p>
                By creating an Account with payinfintech Payment Services the User agrees that payinfintech Payment Services may send the User
                informational, transactional or promotional messages via SMS, WhatsApp, e-mail or any other digital messaging
                medium as part of the normal business operation of the User's use of payinfintech KYC/AML and security consulting Services. This includes compliance status updates, KYC verification results, security alerts, and fraud prevention notifications. The User may opt-out of
                receiving promotional messages from payinfintech Payment Services at any time by indicating that the User no longer
                wishes to receive such messages and notifications. The User acknowledges that opting out of receiving messages
                or e-mail notification may impact the User's use of the Services.
              </p>
            </section>

            <section className="policy-section">
              <h2>NO WARRANTY</h2>
              <p>
                The site, applications, and all materials, documents, KYC/AML compliance frameworks or forms provided on or through the User's use of the
                Site or Applications are provided on an "As Is" and "As Available" basis. To the fullest extent permitted by
                law, payinfintech Payment Services expressly disclaims all warranties of any kind, whether express or implied, including
                but not limited to implied warranties of merchantability, fitness for a particular purpose, title and
                non-infringement.
              </p>
              <p>payinfintech Payment Services makes no warranty that:</p>
              <ul>
                <li>(a) The Site, Applications, or the Materials will meet the User's compliance requirements;</li>
                <li>(b) The Site, Applications, or the Materials will be available on an uninterrupted, timely, secure or error-free basis;</li>
                <li>(c) The results that may be obtained from the use of the Site, Applications, or any KYC/AML verification services or security consulting offered through the Site or Applications, will be accurate or reliable; or</li>
                <li>(d) The quality of any products, services, information or other Materials purchased or obtained by the User through the Site, Applications, or in reliance on the Materials will meet the User's expectations.</li>
              </ul>
              <p>
                Obtaining any Materials through the use of the Site or Applications is done at the User's own discretion and
                at the User's own risk. payinfintech Payment Services makes no warranty regarding any KYC/AML consulting services purchased
                or information obtained through the Site or any transactions entered into through the service.
              </p>
            </section>

            <section className="policy-section">
              <h2>PAYMENT TERMS</h2>
              <p>
                The User, as a Buyer or Purchaser of any KYC/AML consulting service or security solution from payinfintech Payment Services, understands that upon initiating
                a payment transaction, the User is entering into a legally binding and enforceable contract with payinfintech Payment
                Services to purchase the compliance products/services using any electronic payment method, cheque/demand draft/pay order
                or cash on delivery or through any facility as may be authorized by the Reserve Bank of India for payment,
                collection, refund, and remittance.
              </p>
              <p>
                The User warrants that in case the User is making the payment by any electronic payment method, the bank/debit/credit
                card information the User provides is correct and complete; and that the payment made by the User will be honored
                by the User's bank/debit/credit card company.
              </p>
              <p>
                Payment details will be entered by the User directly at the Third Party Payment service provider's webpage and
                payinfintech Payment Services does not have any access whatsoever to the User's payment details.
              </p>
              <p>
                payinfintech Payment Services reserves the right to refuse to accept payments made by any User. In such cases where the
                payment has already been made, payinfintech Payment Services will refund the money to the customer within 7 working days
                of cancelling the Order.
              </p>
              <p>
                All Valid Credit/Debit/Mobile Wallet and any other electronic payment instruments are processed using a Third
                Party Payment system provider. Your use of these Third Party Payment service providers will be governed by the
                terms and conditions agreed between you and your respective Payment Issuing Bank and the Third Party Payment
                system provider. You understand that payinfintech Payment Services is not responsible or liable for the behavior, features,
                or content of your Bank or any Third Party Payment service provider.
              </p>
            </section>

            <section className="policy-section">
              <h2>FOR USE IN INDIA ONLY</h2>
              <p>
                Unless otherwise specified, the material provided by payinfintech Payment Services, including KYC/AML compliance frameworks and security consulting services, is presented solely for the purpose
                of use in India only. payinfintech Payment Services makes no representation that the materials provided by the Site,
                Applications or through any of its channels, are appropriate or available for use in other locations/Countries
                other than India. Those who choose to access payinfintech Payment Services from other locations/Countries other than India,
                do so at their own initiative and payinfintech Payment Services is not responsible for compliance with local laws (outside
                India), if and to the extent local laws are applicable.
              </p>
            </section>

            <section className="policy-section">
              <h2>TERMINATION, SUSPENSION OR DISCONTINUATION OF SERVICE</h2>
              <p>
                payinfintech Payment Services reserves the right to modify, suspend or discontinue, temporarily or permanently, the Site,
                Application and its KYC/AML and security consulting services with or without notice to the User. The user agrees that payinfintech Payment Services shall
                not be liable to the User or any Third Party for any modification or discontinuance of the service. The user
                acknowledges and agrees that any termination of service for any reason may be affected without prior notice and
                acknowledges and agrees that payinfintech Payment Services may immediately delete data and files in the user's account
                and restrict any further access by the User to such files or the Service.
              </p>
            </section>

            <section className="policy-section">
              <h2>DISPUTE RESOLUTION AND JURISDICTION</h2>
              <p>
                Notwithstanding anything to the contrary, this agreement shall be governed by and construed exclusively in
                accordance with the laws of India. Any controversy or claim arising out of or relating to this Agreement or
                payinfintech Payment Services KYC/AML and security consulting services shall be resolved through a two-step Alternate Dispute Resolution ("ADR") mechanism
                in accordance with laws of India. All claims shall be arbitrated on an individual basis and shall not be
                consolidated in any arbitration with any claim or controversy of any other party.
              </p>
              <p>
                Any other dispute or disagreement of a legal nature arising under this agreement shall exclusively be subjected
                to the jurisdiction of the appropriate Courts situated at Raipur, Chhattisgarh (India). It is further agreed
                to by the Parties that the contents of this Section shall survive even after the termination or expiry of the
                Policy and/or Terms.
              </p>
            </section>

            <section className="policy-section">
              <h2>RIGHT TO REFUSE</h2>
              <p>
                The User acknowledges that payinfintech Payment Services reserves the right to refuse service to anyone and to cancel
                User access at any time, including for non-compliance with KYC/AML requirements or security violations.
              </p>
            </section>

            <section className="policy-section">
              <h2>ENTIRE AGREEMENT</h2>
              <p>
                This agreement constitutes the entire and whole agreement between User and payinfintech Payment Services and is intended
                as a complete and exclusive statement of the Terms of the Agreement. This agreement shall supersede all other
                communications between payinfintech Payment Services and its Users with respect to the subject matter hereof and supersedes
                and replaces all prior or contemporaneous understandings or agreements, written or oral, regarding such subject
                matter. If at any time you find these Terms of Use unacceptable or if you do not agree to these Terms of Use,
                Please do not use this Site. We may revise these Terms of Use at any time without prior notice to you. It is
                your responsibility to review these Terms of Use periodically.
              </p>
            </section>

            <section className="policy-section">
              <h2>ACKNOWLEDGEMENT</h2>
              <p>
                By using payinfintech Payment Services KYC/AML and security consulting services or accessing the payinfintech Payment Services Website or Applications, the User acknowledges
                that the User has read these Terms of Use and agrees to be bound by them.
              </p>
              <p>
                User agrees that no warranty or guarantee has been made by payinfintech Payment Services related to any KYC/AML compliance consultation,
                its results or solutions. For purpose of KYC/AML consultation through the payinfintech Payment Services site, it may involve
                electronic communication of User's personal information to external compliance partners and verification services. User consents to allow payinfintech Payment
                Services share the required personal information to the external KYC verification partners, compliance experts, and regulatory authorities for the purpose of online
                identity verification and any other compliance service delivery.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;